// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar{border-radius:50%;cursor:pointer;width:40px;height:40px}", "",{"version":3,"sources":["webpack://./src/lib/components/Header/UserData/Avatar.scss"],"names":[],"mappings":"AAAA,QACE,iBAAA,CACA,cAAA,CACA,UAAA,CACA,WAAA","sourcesContent":[".avatar {\n  border-radius: 50%;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
